<div class="dialog-window">
<div class="modal-header">
    <span class="modal-header-title">{{ 'NOTIFICATION.SETTING_NOTIFICATION' | translate }}</span>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss(false)">
        <svg-icon  src="/assets/images/icons/close.svg" [stretch]="true"
        [svgStyle]="{'width.px':20, 'height.px':20}"></svg-icon>
    </button>
</div>

<div class="modal-body">

    <form class="form" #f="ngForm" [formGroup]="form" autocomplete="off">

            <div formArrayName="notifications">

                <div *ngFor="let item of form.get('notifications')['controls']; let i = index;">
            
                    <div class="row" [formGroupName]="i">

                        <div class="col-12">
                            <div class="form-group">
                                <label class="filter-label" for="legal_form_id"><span class="star">*</span> {{ 'NOTIFICATION.TYPE_OF_NOTIFICATION' | translate }}</label>
                                <ng-select 
                                    id="permission_id" 
                                    class="custom" 
                                    clearAllText="{{ 'CLEAR' | translate }}" 
                                    notFoundText="{{ 'NO_DATA' | translate }}"
                                    bindLabel="name" 
                                    bindValue="id" 
                                    formControlName="notification_type"
                                    placeholder="{{ 'NOTIFICATION.CHOOSE_TYPE_OF_NOTIFICATION' | translate }}"
                                    [loading]="loading" 
                                    [items]="types">
                                </ng-select>
                                <div *ngIf="errorMessages">
                                    <div *ngFor="let item of errorMessages.notification_type">
                                        <div class="text-error" *ngIf="validation(['notifications', i, 'notification_type'], item.type)">
                                            {{ item.message | translate: item.options }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-12">
                            <div class="form-group">
                                <label class="filter-label" for="legal_form_id"><span class="star">*</span> {{ 'NOTIFICATION.CHANNEL_OF_NOTIFICATION' | translate }}</label>
                                <ng-select 
                                    id="permission_id" 
                                    class="custom" 
                                    clearAllText="{{ 'CLEAR' | translate }}" 
                                    notFoundText="{{ 'NO_DATA' | translate }}"
                                    bindLabel="name" 
                                    bindValue="id" 
                                    formControlName="notification_channel"
                                    placeholder="{{ 'NOTIFICATION.CHOOSE_CHANNEL_OF_NOTIFICATION' | translate }}"
                                    [loading]="loading" 
                                    [items]="channels">
                                </ng-select>
                                <div *ngIf="errorMessages">
                                    <div *ngFor="let item of errorMessages.notification_channel">
                                        <div class="text-error" *ngIf="validation(['notifications', i, 'notification_channel'], item.type)">
                                            {{ item.message | translate: item.options }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-12">
                            <div class="form-group">
                                <label class="filter-label" for="delivery_address_{{i}}" class="label"><span class="star">*</span> {{ 'NOTIFICATION.NOTIFICATION_DELIVERY_ADDRESS' | translate }}</label>
                                <input type="text" class="form-control" id="delivery_address_{{i}}" formControlName="delivery_address">
                                <div *ngIf="errorMessages">
                                    <div *ngFor="let item of errorMessages.delivery_address">
                                        <div class="text-error" *ngIf="validation(['notifications', i, 'delivery_address'], item.type)">
                                            {{ item.message | translate: item.options }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="remove-notification-field" *ngIf="form.get('notifications').value.length > 1">
                            <button type="button" class="btn btn-danger" (click)="removeNotificationField(i)"> 
                                <i class="bi bi-trash"></i>
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-12">
                    <div class="add-notification-field">
                        <button type="button" class="btn btn-primary btn-sm" (click)="addNotificationField()"> 
                            <i class="bi bi-plus-circle"></i> {{ 'NOTIFICATION.ADD_SETTING_NOTIFICATION' | translate }}
                        </button>
                    </div>

                </div>
            </div>
    </form>
</div>
    <div class="modal-footer btn-box">
        <button *ngIf="!notificationId" type="button" class="btn btn-primary btn-sm" (click)="onCreate()"
            [disabled]="form.invalid">{{ 'SAVE'| translate}}</button>
        <button *ngIf="notificationId" type="button" class="btn btn-primary btn-sm" (click)="onUpdate()"
            [disabled]="form.invalid">{{ 'SAVE'| translate}}</button>
        <button type="button" class="btn btn-light btn-sm" (click)="activeModal.dismiss(false)">
            {{ 'CLOSE' | translate}}
        </button>
    </div>
</div>